import { Modal } from 'antd'
import { gcpStorageUrl } from 'consts'

import './Dialog.css'

const Dialog = ({
  title,
  className,
  isVisible,
  footerActions,
  onOk,
  onCancel,
  children,
  image,
  ...other
}) => {
  const getTitle = () => {
    return (
      <div className='dialog-title'>
        {image && (
          <div className='dialog-title-image'>
            <img src={`${gcpStorageUrl}/${image}`} alt='dialog-title' />
          </div>
        )}
        <div className='dialog-title-text'>{title}</div>
      </div>
    )
  }

  return (
    <Modal
      className={'dialog-modal ' + className}
      title={getTitle()}
      width={1000}
      centered
      open={isVisible}
      onOk={onOk}
      onCancel={onCancel}
      footer={footerActions}
      closeIcon={<i className='icon-ex close-btn' />}
      {...other}
    >
      {children}
    </Modal>
  )
}

export default Dialog
